import { render, staticRenderFns } from "./NavbarNotifications.vue?vue&type=template&id=7ba49f9e"
import script from "./NavbarNotifications.vue?vue&type=script&lang=js"
export * from "./NavbarNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports